export enum TransferStatus {
  PENDING = 'PENDING',
  BOOKED = 'BOOKED',
  REJECTED = 'REJECTED',
  CANCELED = 'CANCELED',
  UPCOMING = 'UPCOMING',
  RELEASED = 'RELEASED',
}
